import Loadable from 'react-loadable';
import Loading from '../../Components/Loading';

export default Loadable({
  loader: () => import('./FormPage'),
  loading: Loading,
});



// WEBPACK FOOTER //
// ./src/app/views/Pages/FormPage/index.js